import { injectIntl } from 'react-intl';
import {
  getVocabFromField,
  getVocabName,
} from '@plone/volto/helpers/Vocabularies/Vocabularies';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import { normalizeValue } from '@plone/volto/components/manage/Widgets/SelectUtils';
import { useVocab } from '@fhnw/components/VocabContext/useVocab';

//props definition as needed in typescript
export interface FocusPointWidgetProps {
  id: string;
  onChange: Function;
  value: string;
  disabled: boolean;
  default: string;
  isDisabled?: boolean;
}

const FocusPointWidget = injectIntl(
  (props: FocusPointWidgetProps & { intl: any }) => {
    const { id, value, intl, onChange } = props;

    const vocabName = getVocabName(getVocabFromField(props));
    const options = useVocab(vocabName);

    if (!options || !options.length) {
      return null;
    }

    // Make sure that both disabled and isDisabled (from the DX layout feat work)
    const disabled = props.disabled || props.isDisabled;

    let normalizedValue = normalizeValue(
      options || [],
      value || props?.default,
      intl,
    ) as { value: string } | null;

    if (normalizedValue?.value === 'default') {
      normalizedValue = { value: 'center_center' };
    }

    /* eslint-disable jsx-a11y/label-has-associated-control */
    return (
      <FormFieldWrapper {...props} className="focus-point-widget">
        <div className="focus-point-widget__buttons">
          {options.map(
            (option: { value: string; title: string }, i: number) => {
              if (option.value === 'default') {
                return null;
              }
              return (
                <label
                  key={i}
                  className={`focus-point-widget__option focus-point-widget__option--${option.value}`}
                >
                  <input
                    name={id}
                    type="radio"
                    title={option.title}
                    value={option.value}
                    checked={option.value === normalizedValue?.value}
                    disabled={disabled}
                    onChange={() => {
                      return onChange(id, option.value);
                    }}
                  />
                </label>
              );
            },
          )}
        </div>
      </FormFieldWrapper>
    );
    /* eslint-enable */
  },
);

export default FocusPointWidget;
